export default { 
  PublicBeranda: require('./PublicBeranda').default,
  PublicStudi: require('./PublicStudi').default,
  PublicDetail: require('./PublicDetail').default,
  PublicPrakerja: require('./PublicPrakerja').default,
  PrivacyPolicy: require('./PrivacyPolicy').default,
  PublicCallback: require('./PublicCallback').default,
  PublicSiapKerja: require('./PublicSiapKerja').default,
}